import React, { useState } from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Divider,
  Badge,
  IconButton,
  TextField,
} from '@mui/material';

import NotificationsIcon from '@mui/icons-material/NotificationsNone';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
// import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
// import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
// import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SearchIcon from '@mui/icons-material/Search';

import RecordIcon from '@mui/icons-material/Assessment';
import NotificationsContainer from './NotificationsContainer';
import PrivacyContainer from './PrivacyContainer';
import PageTransition from '../PageTransition/PageTransition';

const SectionCard = ({ title, children }) => (
  <Box sx={{ mb: 3 }}>
    {/* Section Title */}
    {title && (
      <Typography
        sx={{
          mb: 1,
          fontSize: 14,
          color: 'text.secondary',
          textAlign: 'left',
        }}
      >
        {title}
      </Typography>
    )}

    {/* Card Container */}
    <Box
      sx={{
        borderRadius: 3,
        bgcolor: '#fff',
        border: '1px solid #F2F2F2',
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  </Box>
);

const SettingsRow = ({
  icon,
  label,
  badge,
  badgeColor,
  badgeTextColor,
  danger,
  onClick,
}) => (
  <ListItem
    disablePadding
    sx={{
      bgcolor: '#FAFAFA',
    }}
    onClick={() => onClick?.()}
  >
    <ListItemButton
      sx={{
        px: 2,
        py: 1.6,
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 40,
          color: danger ? '#D32F2F' : '#6B6B6B',
        }}
      >
        {icon}
      </ListItemIcon>

      <ListItemText
        primary={label}
        primaryTypographyProps={{
          fontSize: 15,
          fontWeight: 500,
          color: danger ? '#D32F2F' : '#2C2C2C',
        }}
      />

      {badge && (
        <Badge
          badgeContent={badge}
          sx={{
            mr: 1,
            '& .MuiBadge-badge': {
              bgcolor: badgeColor || '#fff',
              color: badgeTextColor || '#2C2C2C',
              fontSize: 11,
              height: 18,
              minWidth: 18,
              borderRadius: '10px',
            },
          }}
        />
      )}

      <ChevronRightIcon sx={{ color: '#4D4D4D' }} />
    </ListItemButton>
  </ListItem>
);

const SearchInput = ({ searchQuery, setSearchQuery }) => (
  <TextField
    variant="outlined"
    size="small"
    placeholder="Search...."
    value={searchQuery} // Controlled input
    onChange={e => setSearchQuery(e.target.value)} // Update searchQuery
    InputProps={{
      startAdornment: <SearchIcon sx={{ fill: '#666666' }} />,
      sx: {
        background: '#FAFAFA',
        border: '1px solid #E6E6E6',
        borderRadius: '8px',
        padding: '4px 16px',
      },
    }}
    sx={{
      width: '100%',
      mb: 2,
      '.MuiOutlinedInput-root': {
        borderRadius: '8px',
      },
    }}
  />
);

const MobileSettings = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('');

  const renderSection = section => {
    switch (section) {
      case 'Notification':
        return <NotificationsContainer />;
      case 'Privacy':
        return <PrivacyContainer />;
      default:
        break;
    }
  };

  const handleTabs = tab => {
    setActiveTab(tab);
    setSearchQuery('');
  };

  return (
    <>
      <Box display="flex" alignItems="center" mb={3}>
        {activeTab && (
          <IconButton color="inherit" onClick={() => handleTabs('')}>
            <ArrowBackIosIcon />
          </IconButton>
        )}
        <Typography
          variant="h5"
          component="h1"
          sx={{
            fontWeight: 500,
            color: 'text.primary',
            textAlign: 'left',
          }}
        >
          {activeTab || 'Settings'}
        </Typography>
      </Box>
      {!activeTab?.length ? (
        <Box
          sx={{
            minHeight: '100vh',
            pt: 2,
          }}
        >
          <List disablePadding>
            {/* General */}
            <SectionCard title="General">
              <SettingsRow
                icon={<NotificationsIcon />}
                label="Notification"
                onClick={() => handleTabs('Notification')}
              />
              <Divider sx={{ marginX: '6px', borderColor: '#F2F2F2' }} />
              <SettingsRow 
                icon={<ShieldOutlinedIcon />} 
                label="Privacy" 
                onClick={() => handleTabs('Privacy')}
              />
            </SectionCard>

            {/* System */}
            {/* <SectionCard title="System">
          <SettingsRow
            icon={<WarningAmberOutlinedIcon />}
            label="Reported Issues"
            badge={'05'}
            badgeColor="#FFF0F0"
            badgeTextColor="#D32F2F"
          />
        </SectionCard> */}

            {/* Delete Account */}
            {/* <Box
          sx={{
            mt: 2,
            borderRadius: 3,
            bgcolor: '#FAFAFA',
            border: '1px solid #F2F2F2',
          }}
        >
          <ListItem disablePadding>
            <ListItemButton sx={{ px: 2, py: 1.6 }}>
              <ListItemIcon sx={{ minWidth: 40, color: '#D32F2F' }}>
                <DeleteOutlineIcon />
              </ListItemIcon>

              <ListItemText
                primary="Delete Account"
                primaryTypographyProps={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: '#D32F2F',
                }}
              />
            </ListItemButton>
          </ListItem>
        </Box> */}
          </List>
        </Box>
      ) : (
        <PageTransition trigger={activeTab}>
          {renderSection(activeTab)}
        </PageTransition>
      )}
    </>
  );
};

export default MobileSettings;
